// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__1RToR","title":"Checkbox_title__6CXoC","body":"Checkbox_body__RoJyS","option":"Checkbox_option__rdemc","selected":"Checkbox_selected__0L3Y3"};